import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { AppState } from '../../store/app.state';

@Injectable({
  providedIn: 'root'
})
export class SsoService {

  constructor(private store: Store<AppState>) {}

  isSSO(): Observable<boolean> {
    return this.store.select(state => state.history).pipe(
      map(historyState =>
        historyState.pageHistory.some(url => url.toLowerCase().includes('sso'))
      )
    );
  }

  isLoggedOut(): Observable<boolean> {
    return this.store.select(state => state.history).pipe(
      map(historyState => {
        return historyState.pageHistory.some(url => url.toLowerCase().includes('logout'))
      }

      )
    );
  }

  isError(): Observable<boolean> {
    return this.store.select(state => state.history).pipe(
      map(historyState =>
        historyState.pageHistory.some(url => url.toLowerCase().includes('401') || url.toLowerCase().includes('403'))
      )
    );
  }
}
